import './App.css';
import './styles/packaging.css';
import Landing from './pages/Landing';
import { BrowserRouter, Routes, Route,} from "react-router-dom";
import Error from './pages/Error';
import Services from './pages/Services';
import Moving from './pages/Moving';
import JunkRemoval from './pages/JunkRemoval';
import Blog from './pages/Blog';
import About from './pages/About';
import LaborTypes from './pages/LaborTypes';
import Whyus from './pages/Whyus';
import Contact from './pages/Contact';
function App() {
  return <> 
    <div className="App"> 
      <BrowserRouter>  
        <Routes>    
          <Route path="/" element={<Landing />} />
          <Route path="/moving" element={<Moving />} />
          <Route path="/services" element={<Services />} />
          <Route path="/junkremoval" element={<JunkRemoval />} /> 
          <Route path="/blog" element={<Blog />} /> 
          <Route path="/labortypes" element={<LaborTypes />} />
          <Route path="/whyus" element={<Whyus />} /> 
          <Route path="/about" element={<About />} /> 
          <Route path="/contact" element={<Contact />} /> 
          <Route path="*" element={<Error />} /> 
        </Routes>    
      </BrowserRouter>  
    </div> 
  </>
} 
export default App; 
